/*jshint esversion: 9 */
import React, { Component } from "react";
import { connect } from "react-redux";

import * as actions from "../store/actions/index";
import { doLog } from "../shared/utility";
import Vehicle from "./Vehicle";

class Vehicles extends Component {
  state = {
    
  };

  addInitialVehicleItem() {
    const vehicleFields = null;
    const vehicleItem = {
      vehicleInstance: 0,
      vehicleFields: vehicleFields,
    };

    if (doLog()) console.log("[Vehicles] addInitialVehicleItem vehicleItem:", vehicleItem);
    this.props.onAddToVehicleArray(this.props.vehicleArray, vehicleItem);
    return vehicleItem;
  }

  checkForEmptyArray() {
    if (
      this.props.selectedIncidentTypeData &&
      this.props.selectedIncidentTypeData !== null &&
      this.props.selectedIncidentTypeData.REQUIREVEHICLEINFO === "Y"
    ) {
      if (doLog()) console.log("[Vehicles].checkForEmptyArray RequireProperty:" + this.props.selectedIncidentTypeData.REQUIREVEHICLEINFO);
        const arraySize = this.props.vehicleArray.length;
        if (doLog()) console.log("[Vehicles].checkForEmptyArray arraySize:" + arraySize);
        if (arraySize === 0) {
          this.addInitialVehicleItem();
        }
    }
  }

  componentDidMount() {
    if (doLog()) console.log("[Vehicles].componentDidMount");
    this.checkForEmptyArray();
  }

  componentDidUpdate() {
    if (doLog()) console.log("[Vehicles].componentDidUpdate props:", this.props);
    this.checkForEmptyArray();
  }

  render() {
    if (doLog()) console.log("[Vehicles].render selectedIncidentTypeData:", this.props.selectedIncidentTypeData);
    const content = [];

    if (
      this.props.selectedIncidentTypeData &&
      this.props.selectedIncidentTypeData !== null &&
      this.props.selectedIncidentTypeData.REQUIREVEHICLEINFO === "Y"
    ) {
      if (doLog()) console.log("[Vehicles].render RequireVehicle:", this.props.selectedIncidentTypeData.REQUIREVEHICLEINFO);
      const arraySize = this.props.vehicleArray.length;
      if (doLog()) console.log("[Vehicles].render arraySize:" + arraySize);
      if (arraySize > 0) {
        for (let i = 0; i < arraySize; i++) {
          const item = this.props.vehicleArray[i];
          content.push(<Vehicle key={item.vehicleInstance} item={item} />);
        }
      }
    }

    if (doLog()) console.log("[Vehicles].render content:", content);

    return (
    <div>
        {content}
    </div>
    );
  }
}

const mapStateToProps = (state) => {
  if (doLog()) console.log('[Vehicles].mapStateToProps state:', state);
  return {
    loading: state.auth.loading,
    error: state.auth.error,
    isAuthenticated: state.auth.token !== null,
    authRedirectPath: state.auth.authRedirectPath,
    //
    configuration: state.trans.configuration,
    incidentTypeDataList: state.trans.incidentTypeDataList,
    //
    vehicleArray: state.trans.vehicleArray,
    vehicleInvolvementList: state.trans.vehicleInvolvementList,
    vehicleBodyStyleList: state.trans.vehicleBodyStyleList,
    vehicleMakeList: state.trans.vehicleMakeList,
    vehicleColorList: state.trans.vehicleColorList,
    //
    stateList: state.trans.stateList,
    //
    selectedIncidentTypeData: state.trans.selectedIncidentTypeData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onAddToVehicleArray: (vehicleArray, vehicleItem) =>
      dispatch(actions.addToVehicleArray(vehicleArray, vehicleItem)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Vehicles);
